// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1E7b3","title":"BackImages_title__OVJds","images":"BackImages_images__3ZQuU"};